import React from "react"
import ReactHtmlParser from "react-html-parser";
import { makeStyles, withStyles, createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles"
import MUIDataTable, { TableFilterList } from "mui-datatables"
import {
    Avatar, Button, Card, CardContent, CardHeader, Checkbox, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, List, ListItem,
    ListItemAvatar, ListItemSecondaryAction, ListItemText, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography
} from "@material-ui/core"
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, TimelineSeparator } from "@material-ui/lab"
import CachedIcon from '@material-ui/icons/Cached'
import CloseIcon from '@material-ui/icons/Close'
import TimerOffIcon from '@material-ui/icons/TimerOff'
import Timer3Icon from '@material-ui/icons/Timer3'
import Timer10Icon from '@material-ui/icons/Timer10'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import AssessmentIcon from '@material-ui/icons/Assessment'
import { red, blue, teal, purple, orange, green } from '@material-ui/core/colors'
import { DIYActions } from "../../../actions"
import MUIDataTableHead from "../../custom/MUIDataTableHead"
import FileDropArea from '../../../utils/FileDropArea'
import DoneIcon from "@material-ui/icons/Done"
import Icons from "../../../assets/images/Icons"

const useStyles = makeStyles((theme) => ({
    rootDesktop: { marginTop: theme.spacing(2), marginLeft: theme.spacing(10), marginRight: theme.spacing(10) },
    rootTablet: { marginTop: theme.spacing(2), marginLeft: theme.spacing(5), marginRight: theme.spacing(5) },
    rootMobile: { marginTop: theme.spacing(1), marginLeft: theme.spacing(1), marginRight: theme.spacing(1) },
    coloredpaper: { color: theme.palette.text.secondary, backgroundColor: "#303030" },
    commentCard: { marginLeft: theme.spacing(1), marginRight: theme.spacing(1) },
    tableRow: { display: "table-row", paddingTop: 5, paddingBottom: 5, "&:hover": { backgroundColor: theme.palette.background.secondary } },
    closeButton: { position: 'absolute', right: theme.spacing(1), top: theme.spacing(1), color: red[900] },
}))

const AutoRefreshIcons = {
    BLOCKED: TimerOffIcon,
    TIMER3SEC: Timer3Icon,
    TIMER10SEC: Timer10Icon,
}

const autoRefreshStates = {
    0: "BLOCKED",
    1: "TIMER3SEC",
    2: "TIMER10SEC",
}

const getNextAutoRefreshState = (currentState) => {
    switch (currentState) {
        case "BLOCKED":
            return autoRefreshStates[1]
        case "TIMER3SEC":
            return autoRefreshStates[2]
        case "TIMER10SEC":
            return autoRefreshStates[0]
        default: return autoRefreshStates[0]
    }
}

const AutoRefreshIcon = ({ currentState }) => {
    const Icon = AutoRefreshIcons[currentState]
    return <Icon />
}

const getAutoRefreshTime = (currentState) => {
    switch (currentState) {
        case "BLOCKED":
            return 0
        case "TIMER3SEC":
            return 3000
        case "TIMER10SEC":
            return 10000
        default: return 0
    }
}

const defaults = {
    metadata: { status: 'NEW', data: { columns: {} } },
    data: { status: 'NEW', data: { data: [], count: 0 } },
    pagination: { page: 0, pagesize: 20 },
}

const getMuiTheme = (theme) => createMuiTheme({ ...theme, overrides: { ...theme.overrides, MUIDataTableFilter: { root: { backgroundColor: theme.palette.background.secondary } } } })

const ColoredCheckbox = withStyles({ root: { color: blue[400], '&$checked': { color: green[600] } }, checked: {} })((props) => <Checkbox color="default" {...props} />)

const RSSITicketsDesktopMode = ({ columns, options, data, MUIDatatableComponents }) => { return <MuiThemeProvider theme={getMuiTheme}><MUIDataTable key='tickets-table' data={data.data.data} columns={columns} options={options} components={MUIDatatableComponents} /></MuiThemeProvider> }

const RSSITicketsTabletMode = ({ columns, options, data, MUIDatatableComponents }) => { return <MuiThemeProvider theme={getMuiTheme}><MUIDataTable key='tickets-table' data={data.data.data} columns={columns} options={options} components={MUIDatatableComponents} /></MuiThemeProvider> }

const RSSITicketsMobileMode = ({ columns, options, data, MUIDatatableComponents }) => { return <MuiThemeProvider theme={getMuiTheme}><MUIDataTable key='tickets-table' data={data.data.data} columns={columns} options={options} components={MUIDatatableComponents} /></MuiThemeProvider> }

const FileUploadDialog = ({ mobileLayout = false, action = "EXTRA_FILE_UPLOAD", open = false, onClose = () => { }, data = {}, step = {}, actions = {} }) => {
    const classes = useStyles()
    const [comment, setComment] = React.useState("")
    const [files, setFiles] = React.useState({})

    const fileDropAreaProps = {
        files: files,
        setFiles: setFiles,
        maxFiles: 50,
        dropAreaText: "Drag and drop your files here or Click here",
        typographyProps: { variant: "h3", color: "textSecondary" },
        style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "500px",
            borderWidth: "2px",
            borderRadius: "25px",
            borderColor: "#EEEEEE",
            borderStyle: "dashed",
            color: "#FFFFFF",
            transition: "border 0.3s ease-in-out 0s",
            justify: "center",
        },
        overrideStyles: true,
        validator: (file) => { },
    }

    const clear = () => {
        setComment("")
        setFiles({})
    }

    const onCloseReset = () => {
        onClose()
        clear()
    }

    const onSubmit = () => {
        actions.onSubmit(files, comment).finally(() => {
            onCloseReset()
        })
    }

    const discardFile = (filename) => {
        var choosenFiles = { ...files }
        delete choosenFiles[filename]
        setFiles(choosenFiles)
    }

    return (
        <Dialog open={open} fullWidth maxWidth="xl">
            <DialogTitle disableTypography>
                <Typography variant='h4' color='textSecondary'>File Upload</Typography>
                <Tooltip title='Close'><IconButton aria-label="close" className={classes.closeButton} onClick={onCloseReset}><CloseIcon /></IconButton></Tooltip>
                <Divider style={{ backgroundColor: "#FFFFFF", marginTop: '5px', marginBottom: '5px' }} />
            </DialogTitle>
            <DialogContent>
                <Grid container direction="row" justify="space-between" alignItems="flex-start" spacing={1}>
                    {Object.keys(files).length < 10 ? <Grid item xs={6}><FileDropArea {...fileDropAreaProps} /></Grid> : null}
                    <Grid item xs={Object.keys(files).length < 10 ? 6 : 12}>
                        <Grid container direction="column" justify="flex-start" alignItems="stretch" spacing={1}>
                            <Grid item><TextField fullWidth multiline placeholder="Comments..." rows={10} rowsMax={10} variant="outlined" size="small" color="primary" value={comment} onChange={(event) => setComment(event.target.value)} /></Grid>
                            <Grid item><Typography variant="h4" color="textSecondary" align="left">Selected Files: {Object.keys(files).length} of 10</Typography></Grid>
                            {Object.keys(files).length > 10 ? <Grid item><Typography variant="h4" color="secondary" align="left">Files selected more than the limit</Typography></Grid> : null}
                            <Grid item>
                                <List dense={true} style={{ maxHeight: "200px", overflowX: "auto" }}>
                                    {
                                        Object.entries(files).map(([filename, file], index) => (
                                            <ListItem className={classes.hover} key={filename + "+" + String(index)}>
                                                <ListItemAvatar><Avatar className={classes.fileIcon} src={Icons.file(files[filename].file.filetype)} alt={files[filename].filetype + " - " + filename} /></ListItemAvatar>
                                                <ListItemText><Typography variant="h6" color="textSecondary">{filename}</Typography></ListItemText>
                                                <ListItemSecondaryAction><Grid item><IconButton aria-label="close" color="secondary" onClick={() => discardFile(filename)}><CloseIcon /></IconButton></Grid></ListItemSecondaryAction>
                                            </ListItem>
                                        ))
                                    }
                                </List>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions><Button variant="contained" color="primary" size="small" style={{ width: "250px" }} disabled={!(comment.length !== 0 || (Object.keys(files).length > 0 && Object.keys(files).length <= 10))} onClick={onSubmit}><Typography variant="h6" color="textSecondary">Submit</Typography></Button></DialogActions>
        </Dialog>
    )
}

const CloseComment = ({ open, quantumId, workorder, onClose, onSubmit }) => {
    const classes = makeStyles((theme) => ({
        closeButton: { position: 'absolute', right: theme.spacing(1), top: theme.spacing(1), color: red[900] },
    }))()
    const [comment, setComment] = React.useState("")

    const onCloseReset = () => {
        setComment("")
        onClose()
    }

    const onTicketSubmit = () => {
        onSubmit(comment)
        onCloseReset()
    }

    return (
        <Dialog open={open} fullWidth maxWidth="md">
            <DialogTitle disableTypography>
                <Typography variant='h4' color='textSecondary'>Close Ticket</Typography>
                <Tooltip title='Close'><IconButton aria-label="close" className={classes.closeButton} onClick={onCloseReset}><CloseIcon /></IconButton></Tooltip>
                <Divider style={{ backgroundColor: "#FFFFFF", marginTop: '5px', marginBottom: '5px' }} />
            </DialogTitle>
            <DialogContent>
                <Grid container direction='column' justify='flex-start' alignItems='flex-start' spacing={2}>
                    <Grid item>
                        <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={2}>
                            <Grid item style={{ minWidth: "150px" }}><Typography variant="h5" color="textSecondary">Ticket Id:</Typography></Grid>
                            <Grid item style={{ minWidth: "250px" }}><Typography variant="h5" color="textSecondary">{quantumId}</Typography></Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={2}>
                            <Grid item style={{ minWidth: "150px" }}><Typography variant="h5" color="textSecondary">Workorder:</Typography></Grid>
                            <Grid item style={{ minWidth: "250px" }}><Typography variant="h5" color="textSecondary">{workorder}</Typography></Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={2}>
                            <Grid item style={{ minWidth: "150px" }}><Typography variant="h5" color="textSecondary">Comment:</Typography></Grid>
                            <Grid item style={{ minWidth: "750px" }}><Grid item><TextField autoFocus variant="outlined" fullWidth multiline rows={5} rowsMax={8} value={comment} onChange={(event) => setComment(event.target.value)} /></Grid></Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={2}>
                            <Grid item style={{ minWidth: "150px" }}><Button fullWidth variant="contained" color="primary" size="small" disabled={comment.length < 5} onClick={onTicketSubmit}><Typography variant="h6" color="textSecondary">Close</Typography></Button></Grid>
                            <Grid item style={{ minWidth: "150px" }}><Button fullWidth variant="contained" color="secondary" size="small" onClick={() => setComment("")}><Typography variant="h6" color="textSecondary">Clear</Typography></Button></Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

const History = ({ controls }) => {
    const classes = makeStyles((theme) => ({
        cardroot: { maxHeight: "70vh", minHeight: "35vh", overflowY: "auto" },
        timelineContentCardRoot: { marginBottom: 20 },
        timelineOppositeContent: { flex: 0.1 },
        paper: {},
        closeButton: { position: 'absolute', right: theme.spacing(1), top: theme.spacing(1), color: red[900] },
        create: { backgroundColor: red[700] },
        assign: { backgroundColor: blue[900] },
        stepStart: { backgroundColor: teal[500] },
        stepEnd: { backgroundColor: teal[700] },
        fileUpload: { backgroundColor: orange[500] },
        close: { backgroundColor: purple['600'] },
        default: { backgroundColor: "#FFFFFF" },
        empty: {},
    }))()
    const [showFiles, setShowFiles] = React.useState({ id: 0, file: { fileId: 0, filename: null, type: null } })
    const [previewData, setPreviewData] = React.useState({ data: null, headers: {}, status: 0 })

    const timelineDotClassname = (action) => {
        switch (action) {
            case "CREATE_TICKET": return classes.create
            case "ASSIGN_USER": return classes.assign
            case "STEP_START": return classes.stepStart
            case "STEP_END": return classes.stepEnd
            case "CLOSE_TICKET": return classes.close
            case "FILE_UPLOAD": return classes.fileUpload
            default: return classes.default
        }
    }

    const getCardheaderProps = (title, comment) => {
        if (![undefined, null].includes(comment) && comment.length > 0) {
            comment = ReactHtmlParser(String(comment).replaceAll("\r\n", "\n").replaceAll("\n", "<br>"))
        } else {
            comment = null
        }
        var cardProps = {}
        if (![undefined, null].includes(title) && title.length > 0) {
            cardProps = { ...cardProps, title: title, titleTypographyProps: { variant: "h4", color: "textSecondary" } }
        }
        if (comment !== null) {
            cardProps = { ...cardProps, subheader: comment, subheaderTypographyProps: { variant: "h4", color: "textSecondary" } }
        }
        return cardProps
    }

    const onClose = () => {
        if (showFiles.file.fileId === 0) {
            controls.closeHistory()
            setShowFiles(({ id: 0, file: { fileId: 0, filename: null, type: null } }))
        } else {
            setShowFiles({ ...showFiles, file: { fileId: 0, filename: null, type: null } })
            setPreviewData({ data: null, headers: {}, status: 0 })
        }
    }

    const FileList = ({ files }) => {
        const _filenameext = (files) => {
            var filenameext = {}
            files.map((file) => { filenameext = { ...filenameext, [file.filename]: { name: String(file.filename).substring(0, String(file.filename).lastIndexOf(".")).toUpperCase(), ext: String(file.filename).substring(String(file.filename).lastIndexOf(".") + 1).toUpperCase() } } })
            return filenameext
        }
        const filenameext = _filenameext(files)

        const onView = (id, name, imtid) => {
            setShowFiles({ ...showFiles, file: { fileId: id, filename: name, type: filenameext[name].ext } })
            DIYActions.RSSI.showFile({ fileId: id, imtid }).then((response) => {
                const reader = new FileReader()
                reader.onload = (event) => {
                    setPreviewData({ data: event.target.result, headers: response.headers, status: response.status })
                }
                reader.readAsDataURL(new Blob([response.data], { type: response.headers["content-type"] }))
            })
        }

        console.log(files)
        console.log(filenameext)

        return (
            <TableContainer>
                <Table>
                    <TableBody>
                        {
                            files.map((file) => (
                                <TableRow>
                                    <TableCell><Button fullWidth variant="text" color="primary" size="small"><Typography variant="h5" color="textSecondary">{file.filename}</Typography></Button></TableCell>
                                    <TableCell><Button fullWidth variant="contained" color="primary" size="small" disabled={!["PDF", "HTML", "TXT", "LOG", "PNG", "JPG", "JPEG"].includes(filenameext[file.filename].ext)} onClick={() => onView(file.id, file.filename, file.imtid)}><Typography variant="h6" color="textSecondary">VIEW</Typography></Button></TableCell>
                                    <TableCell><Button fullWidth variant="contained" color="primary" size="small" onClick={() => DIYActions.RSSI.download(file.id, file.filename)}><Typography variant="h6" color="textSecondary">DOWNLOAD</Typography></Button></TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }

    return (
        <Dialog open={controls.open} fullWidth={showFiles.file.fileId === 0} fullScreen={showFiles.file.fileId !== 0} maxWidth="xl" onEntered={controls.getData}>
            <DialogTitle disableTypography>
                {
                    showFiles.file.fileId === 0 ? (
                        <Typography variant='h4' color='textSecondary'>History {'>'} {controls.quantumId} - {controls.workorder}</Typography>
                    ) : (
                        <Typography variant='h4' color='textSecondary'>{showFiles.file.filename}</Typography>
                    )
                }
                <Tooltip title='Close'><IconButton aria-label="close" className={classes.closeButton} onClick={onClose}><CloseIcon /></IconButton></Tooltip>
                <Divider style={{ backgroundColor: "#FFFFFF", marginTop: '5px', marginBottom: '5px' }} />
            </DialogTitle>
            <DialogContent>
                <Card elevation={0} className={showFiles.file.fileId === 0 ? classes.cardroot : classes.empty}>
                    {
                        showFiles.file.fileId === 0 ? (
                            <Timeline align="left">
                                {
                                    controls.records.map((record, index) => (
                                        <TimelineItem key={index}>
                                            <TimelineOppositeContent className={classes.timelineOppositeContent}><Typography variant="h6" color="textSecondary">{record.Timestamp}</Typography></TimelineOppositeContent>
                                            <TimelineSeparator>
                                                <TimelineDot className={timelineDotClassname(record.Action)} />
                                                {record.id > 1 ? <TimelineConnector /> : null}
                                            </TimelineSeparator>
                                            <TimelineContent>
                                                <Card raised className={classes.timelineContentCardRoot}>
                                                    <CardHeader
                                                        {...getCardheaderProps(record.ActionData.title, record.ActionData.comment)}
                                                        action={
                                                            ![undefined, null].includes(record.ActionData.files) && record.ActionData.files.length > 0 ? (
                                                                showFiles.id === record.id ? (
                                                                    <Button variant="contained" color="secondary" size="small" onClick={() => setShowFiles({ id: 0, file: { fileId: 0, filename: null, type: null } })}><Typography variant="h5" color="textSecondary">Hide Files</Typography></Button>
                                                                ) : (
                                                                    <Button variant="contained" color="primary" size="small" onClick={() => setShowFiles({ id: record.id, file: { fileId: 0, filename: null, type: null } })}><Typography variant="h5" color="textSecondary">Show Files</Typography></Button>
                                                                )
                                                            ) : null
                                                        }
                                                    />
                                                    {
                                                        showFiles.id === record.id ? (
                                                            <CardContent>
                                                                <Grid container direction="row" justify="space-between" alignItems="flex-start" spacing={1}>
                                                                    <Grid item xs={8}><Paper className={classes.paper}><FileList files={record.ActionData.files} /></Paper></Grid>
                                                                    <Grid item xs={4}>{/* <Paper className={classes.paper}></Paper> */}</Grid>
                                                                </Grid>
                                                            </CardContent>
                                                        ) : null
                                                    }
                                                </Card>
                                            </TimelineContent>
                                        </TimelineItem>
                                    ))
                                }
                            </Timeline>
                        ) : (
                            <iframe src={previewData.data + "#toolbar=0&view=fitH"} style={{ width: '100%', height: '90vh', border: 'none', background: '#FFFFFF' }} />
                        )
                    }
                </Card>
            </DialogContent>
        </Dialog>
    )
}

export const ExpandedRow = ({ index, rowData, rowDataUpadte, onAction, alldata, setDataUpdate, historyControls, profile }) => {
    const classes = useStyles()
    const data = rowDataUpadte === undefined ? rowData : rowDataUpadte
    const [selectedSection, setSelectSection] = React.useState(null)
    const [dialog, setDialog] = React.useState({ open: false, action: null, stepId: null, actionCode: null, step: {} })

    const actions = {
        onSubmit: (files, comment) => onAction(index, data.QuantumId, data.RSSIWorkorder, dialog.action, dialog.actionCode, dialog.stepId, files, comment)
    }

    const sectionComplete = (sectionId, actionCode, step) => {
        console.log(sectionId, actionCode, step)
        var checked = false
        if (data.Steps[sectionId].Checklist) {
            var itemsCompleted = true
            Object.keys(data.Steps[sectionId].ChecklistItems).map((item) => {
                var step = data.Steps[sectionId].ChecklistItems[item]
                if (itemsCompleted) {
                    itemsCompleted = step.StepCompleted
                }
            })
            checked = itemsCompleted
        } else {
            checked = true
        }
        if (checked) {
            setDialog({ open: true, action: "SECTION_COMPLETE", stepId: sectionId, actionCode: actionCode, step: step })
        }
    }

    const markChecklistItem = (event, ChecklistItemsId, ChecklistItem) => {
        event.stopPropagation()
        if (!ChecklistItem.StepCompleted) {
            DIYActions.RSSI.markChecklistItem({ quantumId: data.QuantumId, workorder: data.RSSIWorkorder, sectionId: selectedSection, checklistitemid: ChecklistItemsId }).then((response) => {
                if (response.data.status === "SUCCESS") {
                    if (![undefined, null].includes(response.data.ticket)) {
                        var newData = [...alldata.data.data]
                        newData[index] = response.data.ticket
                        // setData({status: data.status, data: {count: data.data.count, data: newData}})
                        setDataUpdate({ status: alldata.status, data: { count: alldata.data.count, data: newData } })
                    }
                }
            }).catch(console.error)
        }
    }

    console.log(![undefined, null].includes(data.Steps) && selectedSection !== null ? data.Steps[selectedSection] : data)

    return (
        <React.Fragment>
            {
                ![undefined, null].includes(data.Steps) && Object.keys(data.Steps).length > 0 ? (
                    <React.Fragment>
                        <TableRow classes={{ root: classes.tableRow }}>
                            <TableCell />
                            <TableCell colSpan={13} style={{ padding: 0, margin: 0 }}>
                                <TableContainer>
                                    <Table size="small">
                                        <TableBody>
                                            {
                                                ![undefined, null].includes(data.Steps) ? (
                                                    Object.entries(data.Steps).map(([sectionId, step]) => (
                                                        <React.Fragment>
                                                            <TableRow key={sectionId}>
                                                                {data.TargetUser.Name !== "UNASSIGNED" ? <TableCell variant="body" size="small" align="center" style={{ width: "10px" }}><IconButton size="small" onClick={selectedSection === sectionId ? () => setSelectSection(null) : () => setSelectSection(sectionId)}>{selectedSection === sectionId ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}</IconButton></TableCell> : null}
                                                                <TableCell variant="body" size="small" align="left"><Typography variant="h6" color="textSecondary">{step.SectionName}</Typography></TableCell>
                                                                <TableCell variant="body" size="small" align="left" style={{ width: "150px" }}><Button fullWidth variant="contained" color="primary" size="small" disabled={step.SectionCompleted} onClick={() => sectionComplete(sectionId, step.ActionCode, step)}><Typography variant="h6" color="textSecondary">{step.SectionCompleted ? `Completed` : `Complete`}</Typography></Button></TableCell>
                                                            </TableRow>
                                                            {
                                                                selectedSection === sectionId ? (
                                                                    <React.Fragment>
                                                                        <TableRow key={String(sectionId) + ":detail"}>
                                                                            <TableCell variant="body" size="small" align="left"></TableCell>
                                                                            <TableCell variant="body" size="small" align="left" colSpan={2}><Typography variant="h6" color="textSecondary">{step.label}</Typography></TableCell>
                                                                        </TableRow>
                                                                        {
                                                                            step.Checklist ? (
                                                                                <TableRow key={String(sectionId) + ":checklist"} classes={{ root: classes.tableRow }}>
                                                                                    <TableCell colSpan={3} style={{ padding: 0, margin: 0 }}>
                                                                                        <TableContainer>
                                                                                            <Table size="small">
                                                                                                <TableBody>
                                                                                                    {
                                                                                                        Object.entries(step.ChecklistItems).map(([ChecklistItemsId, ChecklistItem]) => (
                                                                                                            <TableRow key={"ChecklistItem:" + String(ChecklistItemsId)}>
                                                                                                                <TableCell variant="body" size="small" align="center" style={{ width: "30px" }} />
                                                                                                                <TableCell variant="body" size="small" align="center" style={{ width: "10px", padding: 0, margin: 0 }}><ColoredCheckbox checked={ChecklistItem.StepCompleted} onChange={(event) => markChecklistItem(event, ChecklistItemsId, ChecklistItem)} /></TableCell>
                                                                                                                <TableCell variant="body" size="small" align="left" style={{ paddingLeft: "10px" }}><Typography variant="h6" color="textSecondary">{ChecklistItem.step}</Typography></TableCell>
                                                                                                            </TableRow>
                                                                                                        ))
                                                                                                    }
                                                                                                </TableBody>
                                                                                            </Table>
                                                                                        </TableContainer>
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            ) : null
                                                                        }
                                                                    </React.Fragment>
                                                                ) : null
                                                            }
                                                        </React.Fragment>
                                                    ))
                                                ) : null
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </TableCell>
                        </TableRow>
                        <FileUploadDialog open={dialog.open} action={dialog.action} data={data} step={dialog.step} actions={actions} onClose={() => setDialog({ open: false, action: null, stepId: {}, step: {} })} />
                    </React.Fragment>
                ) : (
                    <TableRow classes={{ root: classes.tableRow }}>
                        <TableCell />
                        <TableCell variant="body" size="small" align="center" colSpan={13}><Typography variant="h4" color="textSecondary">No actions provided yet</Typography></TableCell>
                    </TableRow>
                )
            }
        </React.Fragment>
    )
}

const AssignmentDialog = ({ open = false, close, assignMe, selectUser, espworkorder, selectESPWorkorder, users, user, assignUser }) => {
    const classes = makeStyles((theme) => ({
        closeButton: { position: 'absolute', right: theme.spacing(1), top: theme.spacing(1), color: red[900] },
    }))()

    var espworkorders = []
    users.map((_user) => {
        if (_user.Username === user.Username) {
            espworkorders.push(_user.ESPWOS)
        }
    })

    const onChangeUser = (user) => {
        selectUser(user)
        selectESPWorkorder(null)
    }

    return (
        <Dialog open={open} fullWidth maxWidth="xs">
            <DialogTitle disableTypography>
                <Typography variant='h4' color='textSecondary'>Assign User</Typography>
                <Tooltip title='Close'><IconButton aria-label="close" className={classes.closeButton} onClick={close}><CloseIcon /></IconButton></Tooltip>
                <Divider style={{ backgroundColor: "#FFFFFF", marginTop: '5px', marginBottom: '5px' }} />
            </DialogTitle>
            <DialogContent>
                <Grid container direction="column" justify="flex-start" alignItems="stretch" spacing={1}>
                    <Grid item>
                        <Grid container direction="row" justify="space-between" alignItems="center" spacing={1}>
                            <Grid item xs={4}><Typography variant="h6" color="textSecondary">Select User</Typography></Grid>
                            <Grid item xs={8}>
                                <Select fullWidth value={JSON.stringify(user)} onChange={(event) => onChangeUser(JSON.parse(event.target.value))}>
                                    <MenuItem value={JSON.stringify({ "Company": "", "Contact": "", "Email": "", "Name": "UNASSIGNED", "UserId": "", "Username": "" })}>UNASSIGNED</MenuItem>
                                    {users.map((_user) => <MenuItem value={JSON.stringify(_user)}>{_user.Name}</MenuItem>)}
                                </Select>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container direction="row" justify="space-between" alignItems="center" spacing={1}>
                            <Grid item xs={4}><Typography variant="h6" color="textSecondary">Select ESP WO#</Typography></Grid>
                            <Grid item xs={8}>
                                <Select fullWidth value={espworkorder === null ? "NOVAL" : espworkorder} onChange={(event) => selectESPWorkorder(event.target.value === "NOVAL" ? null : event.target.value)}>
                                    <MenuItem value={"NOVAL"}>Select</MenuItem>
                                    {espworkorders.map((wo) => <MenuItem value={wo}>{wo}</MenuItem>)}
                                </Select>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item><Button fullWidth variant="contained" color="primary" size="small" onClick={assignUser}><Typography variant="h6" color="textSecondary">Assign</Typography></Button></Grid>
                    {/* <Grid item><Button fullWidth variant="contained" color="primary" size="small" onClick={assignMe}><Typography variant="h6" color="textSecondary">Assign to me</Typography></Button></Grid> */}
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

const RSSITickets = ({ profile, responsive, openReport }) => {
    const [metadata, setMetadata] = React.useState(defaults.metadata)
    const [data, setData] = React.useState(defaults.data)
    const [dataUpdate, setDataUpdate] = React.useState(defaults.data)
    const [history, setHistory] = React.useState({ open: false, quantumId: null, workorder: null, records: [] })
    const [pagination, setPagination] = React.useState(defaults.pagination)
    const [filters, setFilters] = React.useState({ Customer: profile.customer, TargetCompany: profile.company, Status: 'OPEN' })
    const [selectedRow, setSelectedRow] = React.useState({})
    const [autoRefreshState, setAutoRefreshState] = React.useState(autoRefreshStates[2])
    const [autoRefreshStateInterval, setAutoRefreshStateInterval] = React.useState(null)
    const [doRefresh, setDoRefresh] = React.useState(false)
    const [closeCommentDialog, setCloseCommentDialog] = React.useState({ open: false, index: null, quantumId: null, workorder: null })
    const [assignmentDialog, setAssignmentDialog] = React.useState({
        open: false,
        user: { "Company": "", "Contact": "", "Email": "", "Name": "UNASSIGNED", "UserId": "", "Username": "" },
        users: [],
        status: "NEW",
        payload: { index: null, quantumId: null, workorder: null, espworkorder: null }
    })

    React.useEffect(() => DIYActions.RSSI.getMetadata(setMetadata), [])

    const getTicketsAuto = (paging) => {
        setDataUpdate({ ...dataUpdate, status: 'WORKING' })
        DIYActions.RSSI.getTickets(paging, filters, setDataUpdate)
    }

    React.useEffect(() => {
        var interval = null
        if (autoRefreshStateInterval !== null) {
            clearInterval(autoRefreshStateInterval)
        }
        if (autoRefreshState !== "BLOCKED") {
            interval = setInterval(() => setDoRefresh(true), getAutoRefreshTime(autoRefreshState))
            setAutoRefreshStateInterval(interval)
        } else {
            setAutoRefreshStateInterval(null)
        }
        return interval !== null ? () => clearInterval(interval) : () => { }
    }, [autoRefreshState])

    React.useEffect(() => {
        if (autoRefreshState !== "BLOCKED" && doRefresh) {
            getTicketsAuto(pagination)
            setDoRefresh(false)
        }
    }, [doRefresh])

    const getTickets = (paging) => {
        setData({ status: 'WORKING', data: { data: [], count: 0 } })
        DIYActions.RSSI.getTickets(paging, filters, setData)
    }

    const historyControls = {
        ...history,
        showHistory: (quantumId, workorder) => setHistory({ open: true, quantumId: quantumId, workorder: workorder, records: [] }),
        closeHistory: () => setHistory({ open: false, quantumId: null, workorder: null, records: [] }),
        getData: () => DIYActions.RSSI.getTicketHistory(history.quantumId, history.workorder, (data) => setHistory((current) => { return { ...current, records: data } }))
    }

    const onAction = (index, quantumId, workorder, action, stepNumber, sectionId, files, comment) => {
        var payload = new FormData()
        payload.append("quantumId", quantumId)
        payload.append("workorder", workorder)
        payload.append("action", action)
        payload.append("stepNumber", stepNumber)
        payload.append("comment", comment)
        payload.append("sectionId", sectionId)
        Object.entries(files).map(([filename, file]) => payload.append(filename, file.file))
        return DIYActions.RSSI.onAction(payload).then((response) => {
            if (response.data.status === "SUCCESS") {
                if (![undefined, null].includes(response.data.ticket)) {
                    var newData = [...data.data.data]
                    newData[index] = response.data.ticket
                    // setData({status: data.status, data: {count: data.data.count, data: newData}})
                    setDataUpdate({ status: data.status, data: { count: data.data.count, data: newData } })
                }
            }
            return response
        }).catch(console.error)
    }

    const onPaginationChange = (newPagination) => {
        setPagination(newPagination)
        getTickets(newPagination)
    }

    const column_info = [
        { name: "QuantumId", sort: false, searchable: false, filter: false, display: false },
        { name: "RSSIWorkorder", sort: false, searchable: true, filter: false, display: true },
        { name: "ESPWorkorder", sort: false, searchable: true, filter: false, display: true },
        { name: "Sitename", sort: false, searchable: true, filter: false, display: true },
        { name: "Customer", sort: false, searchable: false, filter: false, display: responsive.isMobile ? false : true },
        { name: "Market", sort: false, searchable: false, filter: false, display: responsive.isMobile ? false : true },
        { name: "Region", sort: false, searchable: false, filter: false, display: responsive.isMobile ? false : true },
        { name: "Technology", sort: false, searchable: false, filter: false, display: responsive.isMobile ? false : true },
        { name: "TargetCompany", sort: false, searchable: false, filter: false, display: false },
        { name: "TargetUser", sort: false, searchable: false, filter: false, display: responsive.isMobile ? false : true },
        { name: "Steps", sort: false, searchable: false, filter: false, display: false },
        { name: "Status", sort: false, searchable: true, filter: true, display: true },
        { name: "CreateTimestamp", sort: true, searchable: false, filter: false, display: responsive.isMobile ? false : true },
        { name: "UpdateTimestamp", sort: true, searchable: false, filter: false, display: true },
        { name: "History", sort: true, searchable: false, filter: false, display: true },
        { name: "Close", sort: true, searchable: false, filter: false, display: true },
    ]

    const columns = column_info.map((col) => (
        {
            name: col.name,
            label: metadata.data.columns[col.name],
            options: {
                display: col.display,
                sort: col.sort,
                searchable: col.searchable,
                filter: col.filter,
                setCellHeaderProps: () => ({ style: { whiteSpace: "nowrap", backgroundColor: "#0a0a0c", fontSize: "1rem", fontWeight: 700 } }),
                setCellProps: () => ({ style: { fontWeight: 500, fontSize: "1rem", letterSpacing: "-0.05px", lineHeight: "20px", color: "#FFFFFF" } }),
                customBodyRenderLite: (dataIndex, rowIndex) => customBodyRenderLite(dataIndex, rowIndex, col),
                customHeadLabelRender: (columnMeta) => customHeadLabelRender(columnMeta, col)
            }
        }
    ))

    const CustomTableFilterList = (props) => {
        const CustomChip = ({ index, label, onDelete }) => { return <Chip style={{ marginRight: 10, marginBottom: 10 }} variant="outlined" color="secondary" label={String(columns[index].label) + ': ' + String(label)} onDelete={onDelete} /> }
        return <TableFilterList {...props} ItemComponent={CustomChip} />
    }

    const MUIDatatableComponents = { TableFilterList: CustomTableFilterList, TableHead: MUIDataTableHead }

    const assignmentDialogHandler = {
        open: (index, quantumId, workorder, espworkorder, targetUser) => {
            DIYActions.RSSI.getMyUsers({ sitename: data.data.data[index]["Sitename"] }).then((response) => {
                if (response.data.status === "SUCCESS") {
                    setAssignmentDialog({ ...assignmentDialog, users: response.data.data, open: true, payload: { index, quantumId, workorder, espworkorder }, user: targetUser })
                }
            }).catch(console.error)
        },
        selectESPWorkorder: (espworkorder) => setAssignmentDialog((current) => { return { ...current, payload: { ...assignmentDialog.payload, espworkorder } } }),
        close: () => setAssignmentDialog(({ open: false, user: { "Company": "", "Contact": "", "Email": "", "Name": "UNASSIGNED", "UserId": "", "Username": "" }, users: [], status: "NEW", payload: { index: null, quantumId: null, workorder: null, espworkorder: null } })),
        selectUser: (user) => setAssignmentDialog((current) => { return { ...current, user: user } }),
        assignMe: () => onAction(assignmentDialog.payload.index, assignmentDialog.payload.quantumId, assignmentDialog.payload.workorder, "TICKET_ASSIGN", null, null, {}, "Ticket assigned to " + profile.fname + " " + profile.lname).then((response) => {
            if (response.data.status === "SUCCESS") {
                setAssignmentDialog(({ open: false, user: { "Company": "", "Contact": "", "Email": "", "Name": "UNASSIGNED", "UserId": "", "Username": "" }, users: [], status: "NEW", payload: {} }))
            }
        }),
        assignUser: () => {
            var payload = new FormData()
            payload.append("quantumId", assignmentDialog.payload.quantumId)
            payload.append("workorder", assignmentDialog.payload.workorder)
            if (assignmentDialog.payload.espworkorder !== null) {
                payload.append("espworkorder", assignmentDialog.payload.espworkorder)
            }
            payload.append("user", JSON.stringify(assignmentDialog.user))
            payload.append("action", "TICKET_ASSIGN_USER")
            payload.append("comment", "Ticket assigned to " + assignmentDialog.user.Name + " by " + profile.fname + " " + profile.lname)
            DIYActions.RSSI.onAction(payload).then((response) => {
                if (response.data.status === "SUCCESS") {
                    setAssignmentDialog(({ open: false, user: { "Company": "", "Contact": "", "Email": "", "Name": "UNASSIGNED", "UserId": "", "Username": "" }, users: [], status: "NEW", payload: {} }))
                    if (![undefined, null].includes(response.data.ticket)) {
                        var newData = [...data.data.data]
                        newData[assignmentDialog.payload.index] = response.data.ticket
                        setDataUpdate({ status: data.status, data: { count: data.data.count, data: newData } })
                    }
                }
            }).catch(console.error)
        }
    }

    const customBodyRenderLite = (dataIndex, rowIndex, col) => {
        return (
            <React.Fragment>
                {
                    col.name === "TargetUser" ? (
                        data.data.data[dataIndex][col.name].Name === "UNASSIGNED" ? (
                            <Button fullWidth variant="contained" color="primary" size="small" onClick={() => assignmentDialogHandler.open(dataIndex, data.data.data[dataIndex]["QuantumId"], data.data.data[dataIndex]["RSSIWorkorder"], data.data.data[dataIndex]["ESPWorkorder"], data.data.data[dataIndex]["TargetUser"])}><Typography variant='h5' color='textSecondary'>Assign</Typography></Button>
                        ) : <Typography variant='h5' color='textSecondary'>{data.data.data[dataIndex][col.name].Name}</Typography>
                    ) : col.name === "History" ? (
                        <Button fullWidth variant="contained" color="primary" size="small" onClick={() => historyControls.showHistory(data.data.data[dataIndex]["QuantumId"], data.data.data[dataIndex]["RSSIWorkorder"])}><Typography variant="h6" color="textSecondary">{col.name}</Typography></Button>
                    ) : col.name === "Close" ? (
                        <Button fullWidth variant="contained" color="primary" size="small" disabled={data.data.data[dataIndex]["Status"] === "CLOSED"} onClick={() => setCloseCommentDialog({ open: true, index: dataIndex, quantumId: data.data.data[dataIndex]["QuantumId"], workorder: data.data.data[dataIndex]["RSSIWorkorder"] })}><Typography variant="h6" color="textSecondary">{col.name}</Typography></Button>
                    ) : <Typography variant='h5' color='textSecondary'>{data.data.data[dataIndex][col.name]}</Typography>
                }
            </React.Fragment>
        )
    }

    const customHeadLabelRender = (columnMeta, col) => {
        return (
            ["History", "Close"].includes(col.name) ? (
                null
            ) : (
                <Typography variant="h5" color="textSecondary">{metadata.data.columns[col.name]}</Typography>
            )
        )
    }

    var options = {
        count: data.data.count,
        page: pagination.page,
        elevation: 16,
        rowsPerPage: pagination.pagesize,
        rowsPerPageOptions: [10, 20, 50],
        selectableRows: "none",
        searchPlaceholder: "Sitename, Customer, Region, Market",
        download: false,
        print: false,
        viewColumns: false,
        reload: true,
        serverSide: true,
        textLabels: {
            body: {
                noMatch: "No open tickets",
                toolTip: "Sort",
                columnHeaderTooltip: column => `Sort for ${column.label}`
            },
            pagination: {
                next: "Next",
                previous: "Previous",
                rowsPerPage: "Pagesize:",
                displayRows: "of",
            },
            filter: {
                all: "All",
                title: "FILTERS",
            },
        },
        responsive: "standard",
        expandableRows: !responsive.isMobile,
        expandableRowsHeader: false,
        expandableRowsOnClick: false,
        onRowClick: responsive.isMobile ? (_, rowState) => setSelectedRow(data.data.data[rowState.dataIndex]) : (_, rowState) => { },
        customToolbar: () => {
            return (
                <React.Fragment>
                    <Tooltip title={<Typography variant="h5" color="textSecondary">Reload Table</Typography>} disableFocusListener><IconButton style={data.status === 'WORKING' || dataUpdate.status === 'WORKING' ? { animation: 'logo-spin infinite 1s linear' } : {}} onClick={() => getTickets(pagination)}><CachedIcon /></IconButton></Tooltip>
                    <Tooltip title={<Typography variant="h5" color="textSecondary">Auto Refresh</Typography>} disableFocusListener><IconButton onClick={() => setAutoRefreshState(getNextAutoRefreshState(autoRefreshState))}><AutoRefreshIcon currentState={autoRefreshState} /></IconButton></Tooltip>
                </React.Fragment>
            )
        },
        handleReload: () => getTickets(pagination),
        onChangeRowsPerPage: (numberOfRows) => onPaginationChange({ ...pagination, pagesize: numberOfRows }),
        onChangePage: (currentPage) => onPaginationChange({ ...pagination, page: currentPage }),
        onTableInit: () => getTickets(pagination),
        onFilterChange: (changedColumn, filterList, type, changedColumnIndex, displayData) => {
            if (changedColumn === null) {
                setFilters({ ...(profile.accesslvl === "superadmin" ? { username: "*" } : profile.accesslvl === "admin" ? { username: "*", customer: profile.customer, company: profile.company } : { username: profile.username }), ticketstatus: 'OPEN' })
            } else {
                if (filterList[changedColumnIndex].length > 0) {
                    setFilters({ ...filters, [changedColumn]: filterList[changedColumnIndex][0] })
                } else {
                    let _filters = filters
                    delete _filters[changedColumn]
                    setFilters(_filters)
                }
            }
        },
    }

    if (!responsive.isMobile) {
        options = {
            ...options,
            renderExpandableRow: (_, rowMeta) => { return <ExpandedRow index={rowMeta.dataIndex} rowData={data.data.data[rowMeta.dataIndex]} rowDataUpadte={dataUpdate.data.data[rowMeta.dataIndex]} onAction={onAction} alldata={data} setDataUpdate={setDataUpdate} historyControls={historyControls} profile={profile} /> },
        }
    }

    const viewProps = { columns, data, options, MUIDatatableComponents, onStateChange: ({ state }) => setVisibleColumns(state) }

    return (
        <React.Fragment>
            {responsive.isMobile ? <RSSITicketsMobileMode {...viewProps} /> : responsive.isTablet ? <RSSITicketsTabletMode {...viewProps} /> : <RSSITicketsDesktopMode {...viewProps} />}
            {!responsive.isMobile ? <History controls={historyControls} /> : null}
            <CloseComment open={closeCommentDialog.open} quantumId={closeCommentDialog.quantumId} workorder={closeCommentDialog.workorder} onClose={() => setCloseCommentDialog({ open: false, index: null, quantumId: null, workorder: null })} onSubmit={(comment) => onAction(closeCommentDialog.index, closeCommentDialog.quantumId, closeCommentDialog.workorder, "TICKET_CLOSE", null, null, {}, comment)} />
            <AssignmentDialog open={assignmentDialog.open} user={assignmentDialog.user} users={assignmentDialog.users} espworkorder={assignmentDialog.payload.espworkorder} selectESPWorkorder={assignmentDialogHandler.selectESPWorkorder} close={assignmentDialogHandler.close} selectUser={assignmentDialogHandler.selectUser} assignMe={assignmentDialogHandler.assignMe} assignUser={assignmentDialogHandler.assignUser} />
        </React.Fragment>
    )
}

export default RSSITickets
